import { ShopConfigResponse } from '../types/contentful/shopConfig';
import { useShopConfigV2 } from './shopConfig';
import { isEuSiteWithAtLeastOneInternationalDestination } from '../util/international';

export const isSellerGeneratedLabelsEnabled = (shopConfig: ShopConfigResponse) => {
  const enabledFulfillmentMethods =
    shopConfig.shippingConfig?.enabledPeerToPeerFulfillmentMethods ?? [];
  if (enabledFulfillmentMethods.length === 1) {
    return enabledFulfillmentMethods[0] === 'PEER';
  }

  return isEuSiteWithAtLeastOneInternationalDestination(shopConfig);
};

export const useSellerGeneratedLabels = () => {
  const shopConfig = useShopConfigV2();
  return isSellerGeneratedLabelsEnabled(shopConfig);
};
